<template>
	<div id="cameraCard" class="cameraCard">
		<div class="photo" v-bind:style=bgcssdata ></div>
		<div class="cardHeader">
			<h3>Live camera of the day <small>{{ cardData.json_object.cam.name }}</small></h3>
		</div>
		<div class="cardActions">
    		<router-link to="/map/cams" class="btn btn-default btn-block" >View More Live Cameras &rarr;</router-link>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'camera-card',
      props: [
        'cardData'
      ],
      computed: {
        storageUrl: function () {
          return this.$store.getters.storageEndpoint
        },
        cameraUrl: function () {
          return this.storageUrl + 'cameras/' + this.cardData.json_object.filename
        },
        bgcssdata: function () {
          return {'background-image': 'url("' + this.cameraUrl + '")'}
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/components/cards/Camera.vue